module.exports = __webpack_public_path__ + "static/media/32-7.5ffcbbbf.mp3";